import router from '..'
import { useAppBootstrap } from '@/composables/useAppBootstrap/useAppBootstrap'
import operatorAuthGuard from './operatorAuthGuard'

export const registerGuards = () => {
  router.beforeEach(async () => {
    const { waitForAppReady } = useAppBootstrap()
    await waitForAppReady()
  })

  operatorAuthGuard()
}
